import { render } from "./IconMap.vue?vue&type=template&id=3a0b77ac"
import script from "./IconMap.vue?vue&type=script&lang=ts"
export * from "./IconMap.vue?vue&type=script&lang=ts"
script.render = render

export default script